module.exports = __webpack_public_path__ + "static/media/kuban-thumb.b9a467c1.webp";